import React from 'react';

import NumberHelper from 'util/number_helper';
import Export from 'components/Explorer/Export';
import SaveSearch from 'components/Explorer/SaveSearch';
import SummaryBlock from 'components/Explorer/ContentPanel/SummaryBlock';
import helpFor from 'util/help.js';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const Summary = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('research_outputs/summary', params, { reloadOn: ['filters'] });

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const loadingFailed = loading === Loading.ERROR;

  const totalOutputs = data?.total_outputs ?? 0;
  const mentionedOutputs = data?.mentioned_outputs ?? 0;

  const content = () => {
    if (loadingFailed) return I18n.t('Explorer.Outputs.error');
    if (totalOutputs === 0) return I18n.t('Explorer.Outputs.Summary.no_results');

    return (
      <div>
        {I18n.htmlSafe('Explorer.Outputs.Summary.research_outputs_html', {
          count: totalOutputs,
          formattedCount: NumberHelper.formatNumberWithDelimiter(totalOutputs)
        })}{' '}
        {I18n.htmlSafe('Explorer.Outputs.Summary.mentions_html', {
          count: mentionedOutputs,
          formattedCount: NumberHelper.formatNumberWithDelimiter(mentionedOutputs)
        })}
      </div>
    );
  };

  return (
    <SummaryBlock>
      {isLoading ? (
        I18n.t('Explorer.Outputs.Summary.loading')
      ) : (
        <>
          <div>{content()}</div>
          <Export endpoint="research_outputs" resultsCount={totalOutputs} help={helpFor('research_outputs')} />
          <SaveSearch endpoint="outputs" analyticsName="Research Outputs" />
        </>
      )}
    </SummaryBlock>
  );
};

export default Summary;
